import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IUserState } from '@/store/getters'
import API from '@/api'
import Utils from '@/utils/utils'
import { Message } from '@lui/lui-ui'
import Cookies from 'js-cookie'

@Module({ dynamic: true, store, name: 'user' })

class User extends VuexModule implements IUserState {
  public token = ''
  public createdCsat = false;
  public accountType = 0
  public fullname = ''
  public username = ''
  public siteCode : number = 0
  public adminSiteCode : number = 0
  public adminSiteName: string = ''
  public siteName = ''
  public siteType: number = 0
  public subType: number = 0
  public processSiteType: number = 0
  public processRole: number = 0
  public avatar = ''
  public email = ''
  public tenantCode = ''
  public personId = ''
  public expire = 0
  public mobile = ''
  public userId = 0
  public orgId = ''
  public orgName = ''
  public hrmDeptId = ''
  public roles = []
  public ssoServiceTicket = Utils.queryUrl(window.location.href).sso_service_ticket
  public loginType = {
    erp: 'sso.jd.com',
    passport: 'pin'
  }
  public tokenKey = this.loginType[process.env.VUE_APP_LOGINTYPE as 'erp']
  public managerSiteInfoList: { code: number; name: string }[] = []

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token
  }

  @Mutation
  private SET_NAME(fullname: string) {
    window.customerCode = fullname
    this.fullname = fullname
  }

  @Mutation
  private SET_TOKEN_KEY(tokenKey: string) {
    this.tokenKey = tokenKey
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
    this.avatar = avatar
  }

  @Mutation
  private SET_USER_NAME(userName: string) {
    window.customerName = userName
    this.username = userName
  }

  @Mutation
  private SET_ADMIN_SITE_CODE(adminSiteCode: number) {
    this.adminSiteCode = adminSiteCode
  }

  @Mutation
  private SET_ADMIN_SITE_NAME(adminSiteName: string) {
    this.adminSiteName = adminSiteName
  }
  @Mutation
  private SET_SITE_CODE(siteCode: number) {
    this.siteCode = siteCode
  }
  @Action
  public setAdminSiteName(name: string) {
    this.SET_ADMIN_SITE_NAME(name)
  }

  @Action
  public setAdminSiteCode(code: number) {
    this.SET_ADMIN_SITE_CODE(code)
  }

  @Action
  public setSiteCode(code: number) {
    this.SET_SITE_CODE(code)
  }

  @Mutation
  private SET_SITE_NAME(siteName: string) {
    this.siteName = siteName
  }

  @Mutation
  private SET_USER_ID(userId: number) {
    this.userId = userId
  }

  @Mutation
  private SET_EMAIL(email: string) {
    this.email = email
  }

  @Mutation
  private SET_ACCOUNT_TYPE(accountType: any) {
    this.accountType = accountType
  }

  @Action
  public async commonErpLogin() {

    // try {
    //   // 校验是否登录成功
    //   // 获取真实ticket并setCookie
    //   const loginRes: any = await API.login({
    //     url: window.location.href,
    //     appCode: process.env.VUE_APP_ERP_APPKEY,
    //     ticket: this.ssoServiceTicket,
    //     code: Utils.queryUrl(window.location.href).code
    //   })
    //   // 未登录
    //   if (loginRes.code === 1) {
    //     const authorizeRes = await API.authorize({
    //       scope: 'openid',
    //       response_type: 'code',
    //       client_id: process.env.VUE_APP_ERP_APPKEY,
    //       state: Date.now(),
    //       redirect_uri: window.location.href
    //     })
    //     const { type, value } = authorizeRes.data
    //     // 根据不同type处理
    //     switch (type) {
    //       case 'RETURN_URL':
    //         window.location.href = value
    //         break
    //       case 'OIDC_CODE':
    //         window.location.href = `${window.location.href}?code=${value}`
    //         break
    //       default:
    //         console.log('commonErpLogin 出现异常！')
    //         break
    //     }
    //   }

    //   return loginRes
    // } catch (error) {
    //   console.log(error)
    // }
  }

  @Action
  public async login() {
    window.location.href = `${process.env.VUE_APP_ERP}/sso/login?ReturnUrl=${encodeURIComponent(window.location.href)}` || '' // erp内网 登录开启
  }

  @Action
  public resetToken() {
    this.SET_TOKEN('')
  }

  @Action
  public async checkLogin() {
    // 强校验
    switch (process.env.VUE_APP_LOGINTYPE) {
      case 'erp':
        const getCheckLoginRes: any = await this.commonErpLogin()
        if (!getCheckLoginRes.code) {
          // 成功后写入用户信息
          const { fullname, username, email, avatar, userId, accountCode } = getCheckLoginRes.data
          // 以防调用逻辑影响业务，切记一定进行catch
          try {
            window.__sgm_uid__ = fullname
          } catch (e) {}
          this.SET_ACCOUNT_TYPE(accountCode)
          this.SET_NAME(fullname)
          this.SET_USER_NAME(username)
          this.SET_EMAIL(email)
          this.SET_AVATAR(avatar)
          this.SET_USER_ID(userId)

          return true
        } else if (getCheckLoginRes.code === 101) {
          // 应用未接入，联系luobinbin5提供erp的 appKey + appToken
          Message({
            type: 'error',
            message: getCheckLoginRes.message
          })

          return false
        }
        break
      default:
        break
    }
  }

    @Mutation
  private SET_PROCESS_SITE_TYPE(processSiteType: number) {
    this.processSiteType = Number(processSiteType)
  }

  @Mutation
    private SET_SITE_TYPE(siteType: number) {
      this.siteType = Number(siteType)
    }

  @Mutation
  private SET_SITE_SUB_TYPE(subType: number) {
    this.subType = Number(subType)
  }

  @Mutation
  private SET_CREATED_CSAT(createdCsat: boolean) {
    this.createdCsat = createdCsat
  }

  @Mutation
  private SET_PROCESS_ROLE(processRole: number) {
    this.processRole = Number(processRole)
  }

   @Mutation
  private SET_SITE_OPTIONS(options: { code: number; name: string }[]) {
    this.managerSiteInfoList = options
  }

  @Action
   public async getUserInfo() {
     // 判断是否存在token作为
     switch (process.env.VUE_APP_LOGINTYPE) {
       case 'erp':
         const resErp:any = await API.getUser()
         if (resErp.code === 0) {
           Cookies.set('pin', resErp.data.pin, { domain: 'itms-eu.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-itms-eu.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-site-eu.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-idms-eu.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'itms-eu-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-itms-eu-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-idms-eu-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-site-eu-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'itms.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-itms.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-site.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-idms.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'itms-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-itms-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-idms-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resErp.data.pin, { domain: 'st-site-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           //  Cookies.set('pin', resErp.data.pin, { domain: '.jd.com', expires: 7 })
           this.SET_NAME(resErp.data.pin)
           this.SET_ACCOUNT_TYPE(resErp.data.accountType)
           this.SET_USER_NAME(resErp.data.accountName)
           this.SET_SITE_CODE(resErp.data.siteCode)
           this.SET_SITE_NAME(resErp.data.siteName)
           this.SET_EMAIL(resErp.data.email)
           this.SET_SITE_TYPE(resErp.data.siteType)
           this.SET_EMAIL(resErp.data.email)
           this.SET_SITE_SUB_TYPE(resErp.data.subType)
           this.SET_PROCESS_SITE_TYPE(resErp.data.processSiteType)
           this.SET_PROCESS_ROLE(resErp.data.processRole)
           this.SET_SITE_OPTIONS(resErp.data.managerSiteInfoList)
         }
         break
       case 'passport':
         const resPassport:any = await API.getUser()
         if (resPassport.code === 0) {
           Cookies.set('pin', resPassport.data.pin, { domain: 'itms.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resPassport.data.pin, { domain: 'st-itms.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resPassport.data.pin, { domain: 'st-site.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resPassport.data.pin, { domain: 'st-idms.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resPassport.data.pin, { domain: 'itms-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resPassport.data.pin, { domain: 'st-itms-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resPassport.data.pin, { domain: 'st-idms-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           Cookies.set('pin', resPassport.data.pin, { domain: 'st-site-gray.jd.com', expires: 7 }) // 每次切换语言，存入cookie，防止刷新丢失
           this.SET_NAME(resPassport.data.pin)

           this.SET_USER_NAME(resPassport.data.accountName)
           this.SET_SITE_CODE(resPassport.data.siteCode)
           this.SET_SITE_NAME(resPassport.data.siteName)
           this.SET_SITE_TYPE(resPassport.data.siteType)
           this.SET_SITE_SUB_TYPE(resPassport.data.subType)
           this.SET_PROCESS_SITE_TYPE(resPassport.data.processSiteType)
           this.SET_PROCESS_ROLE(resPassport.data.processRole)
           this.SET_SITE_OPTIONS(resPassport.data.managerSiteInfoList)
         }
         break
       default:
         break
     }
   }

  @Action
  public async logOut() {
    this.resetToken()
    window.location.href = `${process.env.VUE_APP_ERP_LOGIN_URL}?type=logout&loginSoucre=itms&ReturnUrl=${encodeURIComponent(window.location.href)}` || '' // erp内网 登出
  }

  @Action
  public setAccountType(no: any) {
    this.SET_ACCOUNT_TYPE(no)
  }
}

export const UserModule = getModule(User)
